export default __webpack_public_path__ + "static/media/Green.457500ed.mp4";